import styled from "styled-components";

/* =========================================================================
 * BoardListAdmin (메뉴관리) — Clean SaaS 보조 스타일
 * 페이지 본체/툴바/테이블은 공통 키트(AdminUI)로 구성하고,
 * 여기서는 컬럼 편집 모달과 네이티브 <select> 만 토큰에 맞춰 유지한다.
 * 토큰: primary #2563eb / border #e4e7ec / heading #101828 / muted #667085
 * ========================================================================= */

const FONT_STACK =
  "'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif";

/* 네이티브 select (커스텀 키트 Select는 onChange 시그니처가 달라 폼 로직 보존을 위해 유지) */
export const StyledSelect = styled.select`
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #e4e7ec;
  border-radius: 8px;
  background-color: #ffffff;
  font-family: ${FONT_STACK};
  font-size: 14px;
  color: #101828;
  box-sizing: border-box;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;

  &:focus {
    border-color: #2563eb;
    outline: none;
    box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.18);
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(16, 24, 40, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
`;

export const ModalContent = styled.div`
  background: #ffffff;
  padding: 24px;
  border: 1px solid #e4e7ec;
  border-radius: 12px;
  width: 100%;
  max-width: 560px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.12);
  color: #344054;
  font-family: ${FONT_STACK};
  max-height: 82vh;
  overflow-y: auto;
`;

export const ModalTitle = styled.h2`
  margin: 0 0 18px;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #101828;
  border-bottom: 1px solid #eef0f3;
  padding-bottom: 14px;
  display: flex;
  align-items: center;
  gap: 8px;

  & svg {
    width: 18px;
    height: 18px;
    color: #2563eb;
  }
`;

/* 기존 컬럼 한 줄(라벨 + 인풋 + 삭제 버튼) */
export const ColumnEditRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
`;

/* 신규 컬럼 입력 묶음 카드 */
export const ColumnEditInner = styled.div`
  border: 1px solid #e4e7ec;
  border-radius: 10px;
  background: #fafbfc;
  padding: 16px;
  margin-bottom: 12px;
`;
